import Fileupload from '../fileupload/fileupload';
import Select from '../select/select';
import {isEmail} from '../../utils/helpers';
const EventEmitter = require('event-emitter-es6');

export default class FormField extends EventEmitter {
    constructor(el, input) {
        super();
        this.el = el;
        this.input = input;

        if (this.input.type === 'file') {
            this.fileupload = new Fileupload(this.el);
        }

        if (this.input.className === 'select') {
            this.select = new Select(this.input);
        }

        this.bindEvents();
    }

    bindEvents() {
        this.input.addEventListener('focus', () => this.focused());
        this.input.addEventListener('blur', () => this.blurred());
        this.input.addEventListener('keydown', (event) => this.keydownHandler(event));
    }

    keydownHandler(event) {
        if (event.keyCode === 13) {
            this.emit('enter-pressed');
        }
    }

    focused() {
        this.el.classList.add('is-active');
    }

    blurred() {
        if (this.input.value.length < 1) {
            this.el.classList.remove('is-active');
        }
    }

    getData() {
        let file = false;
        let value = this.input.value;

        if (this.input.type === 'file') {
            file = this.input.value;
            value = this.input.files[0];
        }

        return {
            value: value,
            name: this.input.name,
            file: file
        };
    }

    getValue() {
        return this.input.value;
    }

    reset() {
        this.input.value = '';
        this.el.classList.remove('is-active');

        if (this.input.type === 'file') {
            this.fileupload.reset();
        }
    }

    validate() {
        if (!this.input.required) return true;

        if (this.input.type === 'email') {
            return isEmail(this.input.value);
        } else {
            return this.input.value.length > 1;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/formField/formField.js